export default {"src":"/_next/static/media/enterprise-banner.22272676.svg","height":1280,"width":1280,"blurWidth":0,"blurHeight":0};